import React from 'react';

import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';

interface IProps {
  cardDescription?: string;
}

export const EmptyCatchInfoCard = ({ cardDescription }: IProps) => {
  const availabilityText = 'Data unavailable';

  return (
    <div
      className="flex flex-col justify-between rounded-md bg-lake-fog p-2"
      data-testid="catch-info-card"
    >
      <header>
        <Heading as="h3" className="mx-auto mb-0 text-center" variant="2xs">
          {availabilityText}
        </Heading>
      </header>
      <Text variant="sm" className="mb-0 px-2 text-center text-trench">
        {cardDescription}
      </Text>
    </div>
  );
};
